<template>
	<Col class="menu-content-container width-100 height-100 overflow-y-auto">
		<Col class="pa-2">
			<div :style="{ marginLeft: `${arrowLeft}px` }" class="arrow-container"><SIcon name="publish-dropdown-arrow" /></div>
			<div @click.prevent.stop="" class="menu-title mb-2 ml-2 mt-1">Fix the following issues to {{ nameOfAction }}</div>
			<template v-for="(menuItem, i) in formattedItems">
				<slot name="list-item">
					<PublishErrorsDropdownMenuItem class="px-2" :key="i" :node="menuItem" />
				</slot>
			</template>
		</Col>
	</Col>
</template>

<script>
import { mapActionsShorthand } from '@/store/utils/mappers';
import { setEditNodeClick } from '@/store/modules/selectedNode/actions';
import PublishErrorsDropdownMenuItem from '@/components/Project/PublishButtonDropdown/PublishErrorsDropdownMenuItem.vue';
export default {
	name: 'PublishErrorsDropdownContent',
	components: { PublishErrorsDropdownMenuItem },
	props: {
		problematicNodes: { type: Array },
		nameOfAction: { type: String, required: true },
		arrowLeft: { type: [Number, String], default: 327 },
	},
	computed: {
		formattedItems() {
			return this.problematicNodes.map((node) => ({ ...node, onClick: () => this.goToStep(node) }));
		},
	},
	methods: {
		...mapActionsShorthand({ setEditNodeClick }),
		goToStep(node) {
			this.closeMenu();
			if (!this.isNodeInEdit(node)) {
				return this.setEditNodeClick(node);
			}
		},
		isNodeInEdit(node) {
			return this.$route.params.nodeID === node.id;
		},

		closeMenu() {
			this.$emit('close');
		},
	},
};
</script>
<style scoped lang="scss">
.menu-title {
	font-size: 14px;
	font-weight: bold;
	color: var(--primary-font-color);
}
.arrow-container {
	margin-top: -19px;
	position: fixed !important;
}

.menu-content-container {
	max-height: 300px;
}
</style>
